import React from 'react';

import Notification from 'components/Misc/Notifications/Notification';

import { useNotificationStore } from 'store/useNotificationStore';

const Notifications = () => {
	// Use notification store
	const notifications = useNotificationStore(state => state.notifications);

	return (
		<div className="fixed bottom-0 right-0 z-50 p-4 w-full max-w-xs empty:hidden">
			{notifications?.map(notification =>
				<Notification key={notification.id} notification={notification} />
			)}
		</div>
	);
};

export default Notifications;